import React from "react";

const IMAGE_EXT = ["jpg", "jpeg", "png", "gif", "webp"];

function getExtension(url = "") {
  return url.split(".").pop()?.toLowerCase().split("?")[0];
}

export default function FilePreviewModal({ fileUrl, title, subtitle, onClose }) {
  if (!fileUrl) return null;

  const ext = getExtension(fileUrl);
  const isPdf = ext === "pdf";
  const isImage = IMAGE_EXT.includes(ext);

  return (
    <div className="letters-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="letters-modal">
        <div className="letters-modal-head">
          <div>
            <h3>{title}</h3>
            <p>{subtitle}</p>
          </div>
          <div className="letters-modal-actions">
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              <button type="button">Open in new tab</button>
            </a>
            <a href={fileUrl} download>
              <button type="button" className="primary">Download</button>
            </a>
            <button type="button" className="letters-modal-close" onClick={onClose}>
              ×
            </button>
          </div>
        </div>

        <div className="letters-modal-body">
          {isPdf && <embed src={fileUrl} type="application/pdf" width="100%" height="600px" />}
          {isImage && <img src={fileUrl} alt={title} style={{ maxWidth: "100%" }} />}
          {!isPdf && !isImage && (
            <div className="letters-table-state">
              This file type can't be previewed inline. Use "Open in new tab" or "Download" above.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}